import { SITE_URL } from './siteConfig.js';

export const invitationMeta = [
  {
    path: '/promotion/echoes-of-unforgotten',
    title: 'Echoes of Unforgotten — A Psychological Horror Experience',
    description:
      'Some memories never stay buried. Step into a story-driven psychological horror about guilt, family tragedy, and the echoes of the past.',
    image: `${SITE_URL}/og/echoes-of-unforgotten.jpg`,
    type: 'article',
  },
  {
    path: '/debut/lhyanne-frankie',
    title: "Lhyanne Frankie's 18th Birthday Debut",
    description:
      'You are cordially invited to celebrate a milestone evening of elegance, music, and joy.',
    image: `${SITE_URL}/og/lhyanne-frankie.jpg`,
    type: 'article',
  },
  {
    path: '/debut/jenine-charisse',
    title: "Jenine Charisse's 18th Birthday Celebration",
    description:
      'Join us for an evening of elegance, gratitude, and unforgettable memories as Jenine Charisse celebrates her 18th birthday.',
    image: `${SITE_URL}/og/jenine-charisse.jpg`,
    type: 'article',
  },
  {
    path: '/birthday-christening/camping/n.a-leon-villamor-fortuna',
    title: "N.A. Leon's Camping Birthday & Christening",
    description:
      'Join us for a memorable celebration under the stars — a double celebration of life and faith.',
    image: `${SITE_URL}/og/leon-camping.jpg`,
    type: 'article',
  },
  {
    path: '/birthday-christening/camping',
    title: 'Camping Celebration — Birthday & Christening Invitation',
    description:
      'A bespoke camping-themed digital invitation for birthdays and christenings by E-Invitation Philippines.',
    image: `${SITE_URL}/og/camping-celebration.jpg`,
    type: 'article',
  },
  {
    path: '/invitations/custom/tiara-and-roberto-wedding',
    title: 'Tiara & Roberto — Wedding Invitation',
    description:
      'Together with their families, Tiara Chanil Ramos and Roberto Saliba Jr invite you to celebrate their wedding on Monday, August 10, 2026 at Vikings Luxury Buffet, SM BF Parañaque.',
    image: `${SITE_URL}/og/tiara-and-roberto-wedding.jpg`,
    type: 'article',
  },
  {
    path: '/invitations/custom/fernandez-atizado-nuptial-wedding',
    title: 'Deniel & Merica — Wedding Invitation',
    description:
      'Together with their families, Deniel Fernandez and Merica Atizado invite you to celebrate their wedding on Tuesday, June 30, 2026 at Holy Family Parish Church and Casa Dominguez in Imus, Cavite.',
    image: `${SITE_URL}/og/fernandez-atizado-nuptial-wedding.jpg`,
    type: 'article',
  },
  {
    path: '/invitations/custom/stephen-jan-valerie-rose-wedding',
    title: 'Stephen Jan & Valerie Rose | Wedding Invitation',
    description:
      'Together with their families, Stephen Jan and Valerie Rose invite you to celebrate their wedding on Saturday, September 12, 2026 at St. Therese Parish Church in Dagupan City.',
    image: `${SITE_URL}/og/stephen-jan-valerie-rose-wedding.png`,
    type: 'article',
  },
  {
    path: '/birthday/kaylin-ann-dela-cruz',
    title: "Kaylin Ann Dela Cruz's 7th Birthday — Kuromi Theme",
    description:
      "You're invited to celebrate Kaylin Ann Dela Cruz's magical 7th birthday! A cute Kuromi-themed party on May 23, 2026. RSVP now!",
    image: `${SITE_URL}/og/kaylin-ann-picture.png`,
    type: 'article',
  },
  {
    path: '/invitations/custom/dominick-jhay-ruzol-pareja-birthday',
    title: "Dominick Jhay's 7th Birthday — Roblox Bash",
    description:
      "You're invited to Dominick Jhay's 7th birthday party! A Roblox-themed celebration on May 28, 2026. RSVP now!",
    image: `${SITE_URL}/og/dominick-jhay-ruzol-pareja-birthday.jpg`,
    type: 'article',
  },
  {
    path: '/invitations/custom/sofia-alexandra-debut',
    title: "Sofia Alexandra's 18th Debut — An Enchanted Forest Celebration",
    description:
      'You are warmly invited to celebrate Sofia Alexandra as she turns eighteen on Saturday, July 4, 2026 at Aquatico Royale Resort, Calamba, Laguna. An enchanted forest debut hosted with love by Leah Angeles.',
    image: `${SITE_URL}/og/sofia-alexandra-debut.jpg`,
    type: 'article',
  },
  {
    path: '/invitations/custom/jan-kadence-birthday-and-christening',
    title: "Jan Kadence's Birthday & Christening Invitation",
    description:
      'Join us in celebrating Jan Kadence on Saturday, June 6, 2026 for a Chicago Bulls-themed birthday and christening at San Isidro Labrador Parish and Jollibee Waltermart Naic.',
    image: `${SITE_URL}/og/jan-kadence-birthday-and-christening.jpg`,
    type: 'article',
  },
];
